const Checkmark = () => {
  return (
    <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.87804 9.69418L1.76578 5.8448L0 7.49771L5.87804 13L18 1.65291L16.2342 0L5.87804 9.69418Z" fill="currentColor" />
    </svg>
  )
}

export default Checkmark